import graphql__69552a7ac7e04dbd7f72 from "./__generated__/SubmitTwoFactorCodeMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import mapValues from "lodash/mapValues";
import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__69552a7ac7e04dbd7f72;

async function submitTwoFactorCode(form) {
  const variables = mapValues(form.fields, field => field.value);

  return new Promise((resolve, reject) => {
    commitMutation(appRelayEnvironment, {
      mutation,
      variables,
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(response);
        }
      },
      onError: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}

export { submitTwoFactorCode };
